import React, { FC } from 'react';

import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';
import QuoteLi from '../../assets/icons/quoteLi.svg';
import Arrow from '../../assets/icons/arrowRight200.svg';
import Arrow100 from '../../assets/icons/arrowRight100.svg';
import Ok from '../../assets/icons/okInCircle.svg';
import ArrowDown from '../../assets/icons/arrow-down.svg';

import { RichText } from '../RichText/RichText';

import { QuotesProps } from './Quotes.types';
import * as styles from './Quotes.module.scss';

export const Quotes: FC<QuotesProps> = ({ elements, title, subTitle }) => {
    return (
        <div className={styles.container}>
            <div className={subTitle ? styles.titleFlexContainer : ''}>
                <div className={subTitle ? styles.colLeft : styles.title}>
                    <Text variant="sectionTitle" tag="h2">
                        {title}
                    </Text>
                </div>
                {subTitle && (
                    <div className={styles.subTitleContainer}>
                        <RichText content={subTitle} />
                    </div>
                )}
            </div>

            {elements.map((el, i) => {
                return (
                    <div key={i} className={styles.row}>
                        <div className={styles.mobileHelperArrow}>
                            <div className={styles.containerIconQuote}>
                                <div>
                                    <QuoteLi className={styles.quoteLi} />
                                </div>
                                <p className={styles.quoteText}>{el.problem}</p>
                                <div className={styles.arrowDownIcon}></div>
                            </div>
                            <div className={styles.arrowDownIcon}>
                                <Icon>
                                    <ArrowDown />
                                </Icon>
                            </div>
                        </div>
                        <div className={styles.arrowRightIconBig}>
                            <Arrow />
                        </div>
                        <div className={styles.arrowRightIconMid}>
                            <Arrow100 />
                        </div>

                        <div className={styles.containerIconRightText}>
                            <Icon>
                                <Ok className={styles.okIcon} />
                            </Icon>
                            <p className={styles.rightText}>{el.solution}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
